import { useQuery } from "@tanstack/react-query";

import { GetResourceResponseDto, restRepository } from "@onair/repositories";
import {
	GET_LESSON_RESOURCE_BY_RESOURCE_ID,
	GET_RESOURCE_BY_ID,
	GET_RESOURCE_LINK,
	GET_RESOURCES_BY_IDS,
} from "../../keys";

export const useGetResourceByIdQuery = (id: string, options = {}) => {
	return useQuery({
		...options,
		queryKey: [GET_RESOURCE_BY_ID, id],
		queryFn: async () => {
			if (!id) return null;
			try {
				const response = await restRepository.api.resourceGetById(id);
				return (response.data as GetResourceResponseDto) || null;
			} catch (error) {
				console.error("Failed to fetch resource by ID:", error);
				return null;
			}
		},
		enabled: !!id,
	});
};
export const useQueryResourcesByIds = (ids: string[], options = {}) => {
	return useQuery({
		...options,
		queryKey: [GET_RESOURCES_BY_IDS, ids],
		queryFn: async () => {
			if (ids) {
				const request = ids.map((id) => restRepository.api.resourceGetById(id));
				const response = await Promise.all(request);
				return response.map((res) => res.data) as GetResourceResponseDto[];
			}
		},
		enabled: !!ids && !!ids.length,
	});
};

export const useGetResourceLinkQuery = (
	rootLibraryId: string,
	options = {},
) => {
	return useQuery({
		...options,
		queryKey: [GET_RESOURCE_LINK, rootLibraryId],
		queryFn: async () => {
			if (rootLibraryId) {
				const response =
					await restRepository.api.resourceGetLinkList(rootLibraryId);
				return response.data as GetResourceResponseDto[];
			}
		},
		enabled: !rootLibraryId,
	});
};

export const useGetLessonResourceByResourceIdQuery = (resourceId: string) => {
	return useQuery({
		queryKey: [GET_LESSON_RESOURCE_BY_RESOURCE_ID, resourceId],
		queryFn: async () => {
			if (resourceId) {
				const response =
					await restRepository.api.getLessonResourceByResourceId(resourceId);
				return response.data;
			}
		},
		enabled: !!resourceId,
	});
};
